class FaceDetection {
  private faceDetectionImageRatio: number;
  private faceDetectionImageWidth: number;
  private faceDetectionImageHeight: number;
  private videoWidth: number;
  private videoHeight: number;

  constructor() {
    this.faceDetectionImageRatio = 0;
    this.faceDetectionImageWidth = 0;
    this.faceDetectionImageHeight = 0;
    this.videoWidth = 0;
    this.videoHeight = 0;
  }

  calculateFaceDetectionImageRatio = (videoWidth: number, videoHeight: number, minWidth: number, minHeight: number) => {
    const widthRatio = videoWidth / minWidth;
    const heightRatio = videoHeight / minHeight;

    this.videoWidth = videoWidth;
    this.videoHeight = videoHeight;

    this.faceDetectionImageRatio = Math.max(widthRatio, heightRatio);

    this.faceDetectionImageWidth = Math.floor(videoWidth / this.faceDetectionImageRatio);
    this.faceDetectionImageHeight = Math.floor(videoHeight / this.faceDetectionImageRatio);

    return this.getImageRatio();
  };

  getImageRatio = () => {
    return {
      faceDetectionImageRatio: this.faceDetectionImageRatio,
      faceDetectionImageWidth: this.faceDetectionImageWidth,
      faceDetectionImageHeight: this.faceDetectionImageHeight,
      videoWidth: this.videoWidth,
      videoHeight: this.videoHeight,
    };
  };

  normalizePredictions = (
    predictions: any,
    returnTensors: boolean,
    annotateBoxes: boolean,
    faceDetectionImageRatio: number,
    videoWidth: number,
    videoHeight: number,
  ) => {
    for (let i = 0; i < predictions.length; i++) {
      if (returnTensors) {
        predictions[i].topLeft = predictions[i].topLeft.arraySync();
        predictions[i].bottomRight = predictions[i].bottomRight.arraySync();

        if (annotateBoxes) {
          predictions[i].landmarks = predictions[i].landmarks.arraySync();
        }
      }

      predictions[i].originalTopLeft = [...predictions[i].topLeft];
      predictions[i].originalBottomRight = [...predictions[i].bottomRight];
      predictions[i].originalLandmarks = JSON.parse(JSON.stringify(predictions[i].landmarks));
      if (faceDetectionImageRatio !== 1) {
        predictions[i].originalTopLeft[0] = predictions[i].originalTopLeft[0] * faceDetectionImageRatio;
        predictions[i].originalTopLeft[1] = predictions[i].originalTopLeft[1] * faceDetectionImageRatio;
        predictions[i].originalBottomRight[0] = predictions[i].originalBottomRight[0] * faceDetectionImageRatio;
        predictions[i].originalBottomRight[1] = predictions[i].originalBottomRight[1] * faceDetectionImageRatio;

        if (annotateBoxes) {
          for (let j = 0; j < predictions[i].landmarks.length; j++) {
            predictions[i].originalLandmarks[j][0] = predictions[i].originalLandmarks[j][0] * faceDetectionImageRatio;
            predictions[i].originalLandmarks[j][1] = predictions[i].originalLandmarks[j][1] * faceDetectionImageRatio;
          }
        }
      }

      if (
        !(
          predictions[i].originalLandmarks[0][0] < 0 ||
          predictions[i].originalLandmarks[0][0] > videoWidth ||
          predictions[i].originalLandmarks[1][0] < 0 ||
          predictions[i].originalLandmarks[1][0] > videoWidth ||
          predictions[i].originalLandmarks[2][0] < 0 ||
          predictions[i].originalLandmarks[2][0] > videoWidth ||
          predictions[i].originalLandmarks[3][0] < 0 ||
          predictions[i].originalLandmarks[3][0] > videoWidth ||
          predictions[i].originalLandmarks[4][0] < 0 ||
          predictions[i].originalLandmarks[4][0] > videoWidth ||
          predictions[i].originalLandmarks[5][0] < 0 ||
          predictions[i].originalLandmarks[5][0] > videoWidth ||
          predictions[i].originalLandmarks[0][1] < 0 ||
          predictions[i].originalLandmarks[0][1] > videoHeight ||
          predictions[i].originalLandmarks[1][1] < 0 ||
          predictions[i].originalLandmarks[1][1] > videoHeight ||
          predictions[i].originalLandmarks[2][1] < 0 ||
          predictions[i].originalLandmarks[2][1] > videoHeight ||
          predictions[i].originalLandmarks[3][1] < 0 ||
          predictions[i].originalLandmarks[3][1] > videoHeight ||
          predictions[i].originalLandmarks[4][1] < 0 ||
          predictions[i].originalLandmarks[4][1] > videoHeight ||
          predictions[i].originalLandmarks[5][1] < 0 ||
          predictions[i].originalLandmarks[5][1] > videoHeight
        )
      ) {
        predictions[i].isCorrect = true;
      }
    }

    return predictions.filter((predict: { isCorrect: boolean }) => predict.isCorrect);
  };
}

export default FaceDetection;
